import { render, staticRenderFns } from "./ChooseLikeMovieView.vue?vue&type=template&id=441c6e4b&"
import script from "./ChooseLikeMovieView.vue?vue&type=script&lang=js&"
export * from "./ChooseLikeMovieView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports